import { mixpanelIntegrationName } from '@/features/integrations';
import type { Integration } from '@/services/db/integration/entity';

/** Where on the page the click happened, as the wire contract spells it. */
export const CLICKED_ON = {
  logoOrTitle: 'Logo or Title',
  button: 'Button',
} as const;

export type ClickedOn = (typeof CLICKED_ON)[keyof typeof CLICKED_ON];

/** Authenticated detail page; the public catalog sends a different source. */
const SOURCE = 'In-App';

type AnalyticsFields = Pick<Integration, 'name' | 'category' | 'type'>;

export function landingPageButtonClickedProperties(integration: AnalyticsFields, clickedOn: ClickedOn) {
  return {
    'Integration Name': mixpanelIntegrationName(integration.name),
    'Integration Category': integration.category,
    'Integration Type': integration.type,
    'Integration Clicked On': clickedOn,
  };
}

/** Properties for the use-case link event. Not `use…`-prefixed: it is not a hook. */
export function linkClickedProperties(integration: AnalyticsFields, url: string) {
  return {
    Source: SOURCE,
    'Integration Name': mixpanelIntegrationName(integration.name),
    'Integration Category': integration.category,
    'Integration Type': integration.type,
    'Integration Link URL': url,
  };
}
